import Header from "../header/Header";
import styles from "./PageContent.module.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import MissingPage from "../../pages/missingPage/MissingPage";
import routes from "../../routes";
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from "../../reduxSlices/headerSlice";
import { updateSelectedReport } from "../../reduxSlices/packageSlice";
import { toast } from "react-toastify";
import { toastConfig } from "../../constants/constant";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useState, useEffect } from "react";
import Footer from "../../components/footer/Footer";
import CustomTooltip from "../../components/tooltip/CustomTooltip";
import { BASE_URL } from "../../constants/constant";
import { Service } from "../../services/service";
import moment from "moment-timezone";
import { reportsOrderList } from "../../helpers/helper";

const service = new Service();

function PageContent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const isUserReview = window.location.href.includes("user-review");
  const isSetupOrganisation =
    window.location.href.includes("setup-organisation");
  const headerData = useSelector((state) => state.header.header);
  const reportsData = useSelector(
    (state) => state?.package?.allPackageByOrganisationId?.reportsData
  );
  const [reportsListData, setReportsListData] = useState(reportsData);
  const selectedReport = useSelector((state) => state?.package?.selectedReport);
  const [favReportsList, setFavReportsList] = useState([]);
  const currUserId = useSelector(
    (state) => state?.user?.currentUser?.data?.userId
  );

  console.log("reportsData<<<<<", reportsData);

  const handleClick = (data) => {
    const reportTitle = data?.reportDetails?.reportName ?? "";
    const reportCategory = data?.reportDetails?.reportCategory ?? "";
    const envLastUpdated = data?.envLastUpdated ?? "";
    if (envLastUpdated != "") {
      var timeZone = moment.tz.guess();
      var timeZoneOffset = new Date(envLastUpdated).getTimezoneOffset();
      var tmzone = moment.tz.zone(timeZone).abbr(timeZoneOffset);
    }
    const groupId = data?.groupId ?? "";
    const reportId = data?.pbReportId ?? "";
    const profileId = data?.profileId ?? "";
    if (groupId && reportId && profileId) {
      dispatch(
        setHeader({
          page: "powerbi",
          title: "",
          subTitle: "",
        })
      );
      dispatch(updateSelectedReport(data));
      navigate(`/reports/${reportTitle}/${groupId}/${reportId}/${profileId}`, {
        state: {
          reportCategory: reportCategory,
          envLastUpdated: envLastUpdated,
          timezone: tmzone,
        },
      });
    } else {
      toast.warning(
        "The specified report has not been uploaded for the organization.",
        toastConfig
      );
    }
  };

  const handleClickOpen = () => {
    setIsOpen((prev) => !prev);
  };

  const markAsFavourite = (e, report) => {
    e.stopPropagation();
    var selectedReport = reportsData.filter(
      (e) => e.pbReportId == report.pbReportId
    )[0];
    updateFavReports(selectedReport);
  };

  useEffect(() => {
    getFavReports();
  }, [reportsData]);

  const getFavReports = async () => {
    if (!currUserId) return;
    let url = `${BASE_URL}/api/Report/GetFavouriteReports?userId=` + currUserId;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.testGetApi(url, {}, user_token);
      let resp = data;
      console.log("resp", resp);
      if (resp?.data && resp?.status == 200) {
        setFavReportsList(resp?.data);
        let favList = resp?.data;
        let fReports = reportsData?.filter((e) =>
          favList.includes(e.pbReportId)
        );
        let allReports = fReports?.concat(
          reportsData?.filter((e) => !favList.includes(e.pbReportId))
        );
        if (allReports) {
          var sortedReports = allReports;
          const masterOrder = reportsOrderList.flatMap((s) => s.value);
          sortedReports = sortedReports.sort((a, b) => {
            const indexA = masterOrder.indexOf(a.reportDetails?.reportName);
            const indexB = masterOrder.indexOf(b.reportDetails?.reportName);

            if (indexA > -1 && indexB > -1) return indexA - indexB;
            if (indexA > -1) return -1;
            if (indexB > -1) return 1;
            return 0;
          });
          setReportsListData(sortedReports);
        }
      } else {
        //  setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      //setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const updateFavReports = async (report) => {
    if (!currUserId) return;
    let url =
      `${BASE_URL}/api/Report/MarkAsFavourite?reportId=` +
      report?.pbReportId +
      `&userId=` +
      currUserId;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.testGetApi(url, {}, user_token);
      let resp = data;
      console.log("resp", resp);
      if (resp?.data && resp?.status == 200) {
        toast.success("Report details has been updated", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getFavReports();
        // setLoader(false);
      } else {
        //  setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      //setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <div
        className={
          isUserReview || isSetupOrganisation
            ? styles.fullRightContainer
            : styles.rightContainer
        }
        style={{ display: headerData.page === "powerbi" ? "flex" : "" }}
      >
        {headerData.page === "powerbi" && (
          <div
            className={styles.mainDiv}
            style={{
              width:
                headerData.page === "powerbi" ? (isOpen ? "20%" : "0%") : "",
            }}
          >
            <div
              className={styles.childDiv}
              style={{ paddingRight: isOpen ? "12px" : "" }}
            >
              {reportsListData &&
                reportsListData?.map((elem, i) => (
                  <div
                    className={`${styles.container} ${
                      selectedReport &&
                      selectedReport?.pbReportId === elem?.pbReportId
                        ? styles.selected
                        : ""
                    }`}
                    key={i}
                    onClick={() => handleClick(elem)}
                  >
                    <div className={styles.favicongrp1}>
                      {elem?.pbReportId != null ? (
                        <CustomTooltip
                          title={
                            !favReportsList.includes(elem?.pbReportId)
                              ? "Mark as Favourite"
                              : "Remove from Favourites"
                          }
                          placement="bottom"
                        >
                          {!favReportsList.includes(elem?.pbReportId) ? (
                            <img
                              alt=""
                              onClick={(e) => markAsFavourite(e, elem)}
                              className={styles.favicon}
                              src={
                                require(`../../assets/images/Mark-Favourite.svg`)
                                  .default
                              }
                            />
                          ) : (
                            <img
                              alt=""
                              onClick={(e) => markAsFavourite(e, elem)}
                              className={styles.favicon}
                              src={
                                require(`../../assets/images/Is-Favourite.svg`)
                                  .default
                              }
                            />
                          )}
                        </CustomTooltip>
                      ) : (
                        <div className={styles.emptyFavicon}></div>
                      )}
                    </div>
                    <div className={styles.contentDiv}>
                      <div className={styles.acquisitonRetention1}>
                        <div className={styles.namegrp}>
                          <div className={styles.reportName}>
                            {" "}
                            {elem?.reportDetails?.reportName || "NA"}
                          </div>
                        </div>
                        <div className={styles.icongrp}>
                          <div className={styles.favicongrp}>
                            {elem?.reportDetails?.reportCategory == null ? (
                              <img
                                alt=""
                                className={styles.reporticon}
                                src={
                                  require(`../../assets/images/Chart1b.svg`)
                                    .default
                                }
                              />
                            ) : (
                              <img
                                alt=""
                                className={styles.reporticon}
                                src={require(`../../assets/images/${elem?.reportDetails?.reportCategory}.png`)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      {/* <div className={styles.fundraising}>
                        {elem?.reportDetails?.reportCategory || "NA"}
                      </div> */}
                    </div>
                  </div>
                ))}
            </div>
            <button className={styles.expendButton} onClick={handleClickOpen}>
              <DragIndicatorIcon />
            </button>
          </div>
        )}
        <div
          style={{
            width:
              headerData.page === "powerbi" ? (isOpen ? "80%" : "100%") : "",
          }}
        >
          <Header />
          <div
            className={`${styles.rectangleContainer} table_container`}
            style={{
              height:
                isUserReview || isSetupOrganisation
                  ? "calc(100vh - 165px)"
                  : headerData.page === "powerbi"
                  ? "calc(100vh - 104px)"
                  : "calc(100vh - 190px)",
            }}
          >
            <Routes>
              {routes.map((route, key) => {
                return (
                  <Route
                    key={key}
                    exact={true}
                    path={`${route.path}`}
                    element={<route.component test="test" />}
                  />
                );
              })}

              {/* Redirecting unknown url to 404 page */}
              <Route path="*" element={<MissingPage />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default PageContent;
